import { LegalLayout } from '@/components/Legal/LegalLayout';
import { TERMS_INTRO, TERMS_SECTIONS, TERMS_EFFECTIVE_DATE } from '@/content/legalContent';

export function TermsPage() {
  return (
    <LegalLayout
      title="Terms & Conditions"
      effectiveDate={TERMS_EFFECTIVE_DATE}
      intro={TERMS_INTRO}
      sections={TERMS_SECTIONS}
    />
  );
}
